<template>
    <div class="flat-view">
        <amf-form class="container">
            <div class="row">
                <span class="title">{{ title }}</span>
            </div>
            <div class="mt-4">
                <component :is="component" :questions="questions" :employerId="employerId" @next="next" @restart="restart" />
            </div>
        </amf-form>
    </div>
</template>

<script>
import Vue from 'vue';
import Instructions from './Nondiscrimination/POP/Instructions.vue'
import Results from './Nondiscrimination/POP/Results.vue';
import { clearAnswers } from './Nondiscrimination/POP/helpers';
import step1 from './Nondiscrimination/POP/step1'
import step2 from './Nondiscrimination/POP/step2'
import step3 from './Nondiscrimination/POP/step3'
import step3a from './Nondiscrimination/POP/step3a'
import step3b from './Nondiscrimination/POP/step3b'
import step4 from './Nondiscrimination/POP/step4'
import step5 from './Nondiscrimination/POP/step5'
import step5a from './Nondiscrimination/POP/step5a'
import step6 from './Nondiscrimination/POP/step6'
import step7 from './Nondiscrimination/POP/step7'

let stepsArray = [
    step1(),
    step2(),
    step3(),
    step3a(),
    step3b(),
    step4(),
    step5(),
    step5a(),
    step6(),
    step7()
]

let components = stepsArray.reduce((comp, question) => {
    comp[question.step] = Vue.component(question.step, question);
    return comp;
}, {});

export default {
    components: { Instructions, Results },
    props: { employerId: { type: String, required: true } },
    data() {
        return {
            questions: [],
            component: 'instructions',
            amfOptions: { noTracking: true, }
        }
    },
    computed: {
        ...amfx.map('employer', 'name'),
        title() {
            let name = this.name ? ` - ${this.name}` : '';
            return `POP Nondiscrimination Testing${name}`
        },
        passed() {
            return this.questions.every(q => q.passed === true);
        },
        showNext() {
            return !this.finished;
        }
    },
    created() {
        clearAnswers();
    },
    methods: {
        restart() {
            clearAnswers();
            this.questions = [];
            this.component = 'instructions';
        },
        next(data) {
            var self = this;
            if(data && data.step)
                this.questions.push(data);

            if(data.nextComponent)
                this.component = components[data.nextComponent];
            else
                showResults();
            
            function showResults() {
                self.component = 'results';
            }
                
        }
    }
}
</script>

<style lang="scss" scoped>
    .title {
        margin: 1.1rem;
        font-size: 1.35rem;
    }
    .main-headers {
        text-align: center;
    }
    .row{
        margin-top: 0.5rem;
        margin-bottom: 0.5rem;
    }
    .info-needed-list {
        padding: 0;
        list-style-type: none;
    }
</style>



// WEBPACK FOOTER //
// src/shared/PopNondiscriminationTesting.vue